import { AxiosInstance } from 'axios'

export interface SocialCustomerPayload {
    cid: string
    socialPlatform: 'Line' | 'Facebook'
    avatarUrl: string
    osPlatform: 'ANDROID' | 'IOS' | 'WEB'
    socialPlatformId: string
    language: 'TH' | 'EN'
}

export default (api: AxiosInstance) => ({
    async save(payload: SocialCustomerPayload) {
        const result = await api.post<void>('/customer/social', payload)
        return result.data
    },
})
